const SYDNEY = "Australia/Sydney";
const MONTH_NAMES = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

/** "YYYY-MM" of `now` in Sydney — the month the usage files are keyed by. */
export function currentMonth(now: Date = new Date()): string {
  const parts = new Intl.DateTimeFormat("en-AU", {
    timeZone: SYDNEY,
    year: "numeric",
    month: "2-digit",
  }).formatToParts(now);
  const year = parts.find((p) => p.type === "year")?.value ?? "1970";
  const month = parts.find((p) => p.type === "month")?.value ?? "01";
  return `${year}-${month}`;
}

/** The last `n` months ending at `now`'s Sydney month, newest first. */
export function lastMonths(now: Date = new Date(), n = 12): string[] {
  const [y, m] = currentMonth(now).split("-").map(Number) as [number, number];
  const out: string[] = [];
  for (let i = 0; i < n; i += 1) {
    const idx = m - 1 - i;
    const year = y + Math.floor(idx / 12);
    const month = ((idx % 12) + 12) % 12;
    out.push(`${year}-${String(month + 1).padStart(2, "0")}`);
  }
  return out;
}

/** "2026-09" → "Sep 2026". An unparseable month keeps its own digits. */
export function monthLabel(month: string): string {
  const [y, m] = month.split("-");
  return `${MONTH_NAMES[Number(m) - 1] ?? m} ${y}`;
}

export function daysInMonth(month: string): number {
  const [y, m] = month.split("-").map(Number) as [number, number];
  return new Date(Date.UTC(y, m, 0)).getUTCDate();
}
